import { Directive, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[customMax][formControlName],[customMax][formControl],[customMax][ngModel]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomMaxDirective, multi: true}],
})
export class CustomMaxDirective implements Validator {
  @Input() customMax: number;
  
  validate(c: UntypedFormControl): {[key: string]: any} {
      let v = c.value;
      if (v && (typeof c.value === 'string')){ v = Number(c.value); }
      return (v && ( v > this.customMax)) ? {customMax: true} : null;
  }
} 
